import { render, staticRenderFns } from "./btm2.vue?vue&type=template&id=a22ff284&"
import script from "./btm2.vue?vue&type=script&lang=js&"
export * from "./btm2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports